import { JwtPayload } from 'jwt-decode';

export enum IReportPackageEnum {
  Basic = 'M',
  Pro = 'L',
}

export enum CompanySetupStatusEnum {
  Pending = 'ValidierungAnstehend',
}

export enum UserProfileSetupStatusEnum {
  Pending = 'EinstellungenAnstehend',
}

export type IReportJwtPayload = JwtPayload & {
  email: string;
  role: string;
  userid: string;
  companyid: string;
  companyname: string;
  companystatus: string;
  userstatus: string;
  ireportpackage: keyof typeof IReportPackageEnum;
  testdataactive?: string;
};
